import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker'
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarWeek } from '@fortawesome/free-solid-svg-icons';
import "./grant.css"
import "react-datepicker/dist/react-datepicker.css"

export default function ExpireInput (props) {
  const CalButtonInput = forwardRef(({ value, onClick, className }, ref) => (
      <FontAwesomeIcon icon={faCalendarWeek} size="lg"
        className={className} onClick={props.onClick} ref={ref}/>
    ),
  );
  const FormInput = forwardRef(({ value, onClick }, ref) => (
    <input type="text" onClick={onClick} ref={ref} id={props.id}
    value={value} className={props.className} size={props?.size} onChange={props.onChange} />
  ));
  const MyContainer = ({ className, children }) => {
    return (
      <div style={{background: "white", color: "#fff", border: '1px darkgray' }}>
        <div className={className}>
          {props?.buttonInput ? 
            <div style={{ background: "#f0f0f0" }}>
              Approve with custom expiration date
            </div>
            : null}
          <div style={{ position: "relative" }}>{children}</div>
        </div>
        <div className="calendar-buttons">
            <Button onClick={oneYear}>1 year</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button onClick={neverExpire}>Never Expires</Button>
          </div>
      </div>
    );
  };
  const oneYear=() => {
    const aYear = new Date()
    aYear.setFullYear(aYear.getFullYear() + 1)
    props.onChange(aYear)
  }
  const neverExpire=() => {
    const never = new Date()
    never.setFullYear(never.getFullYear() + 1000)
    props.onChange(never)
  }
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  const longAgo = new Date()
  longAgo.setFullYear(yesterday.getFullYear() - 10)
  const customInput = props?.buttonInput ? <CalButtonInput className="grant-button" /> :
    <FormInput />
  return (
    <DatePicker className="compact-item " size='35' selected={props.from} selectsStart 
      startDate={props.from} 
      excludeDateIntervals={[{start:longAgo, end:yesterday},]}
      customInput={customInput}
      onChange={props.onChange} open={props.open}
      onBlur={props.onBlur}
      dateFormat="MMM d, yyyy"
      calendarContainer={MyContainer}
    />
  )
}
